import { useContext, useState,useMemo } from "react";
import MultiComparisonComponent from "../../Dashboard/Component/MultiComparisonComponent";
import { DiscoveryContext } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./MarketSummary.module.css";
import { AuthContext } from "../../../context/auth-context";
import { useIsSelectedSection } from "../discovery-context";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import { filterKey } from "../BrandAudit";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Modal from "../../../Component/Modal/Modal";
import Share from "../Share/Share";
import { toast } from "react-toastify";

export default function MarketSummary() {

  const discoveryCtx = useContext(DiscoveryContext);
  const [showShareModal, setShowShareModal] = useState(false);
  const { user } = useContext(AuthContext);
  let primary_llm = discoveryCtx.primary_llm;
  let primaryMarket = discoveryCtx.markets[0];
  let llms = discoveryCtx.llm;
  const selectedCategory = discoveryCtx.state.selectedCategory
  const selectedMarket = discoveryCtx.state.selectedMarket;
  const selectedPersona = discoveryCtx?.state?.selectedPersona;
  const id = "Market_Summary";
  /*we need to pass uniqueKey because it only selectedCategory*/
  let uniqueKey = `${tab.marketOverview}_${id}_${selectedCategory}_${selectedPersona}`;
  const { checked } = useIsSelectedSection({
    id,
    tab: tab.marketOverview,
    uniqueKey,
  });

const personaOptions = useMemo(() => {
  return (discoveryCtx?.persona || [])
    .map(p => {
      // New record format
      if (typeof p === "object" && p?.title) {
        return {
          name: p.title,
          value: p.title,
        };
      }

      // Old record format
      if (typeof p === "string") {
        return {
          name: p,
          value: p,
        };
      }

      return null;
    })
    .filter(Boolean);
}, [discoveryCtx?.persona]);



  const getBrandScores = (type) => {
    const brandScoresMap = {};
    let mainBrandProduct = null;

    if (!Array.isArray(llms) || llms.length === 0) {
      console.warn("No LLMs available in discoveryCtx");
      return { brandScoresMap, mainBrandProduct };
    }

    llms.forEach((llm) => {
      const scores = discoveryCtx?.brand_scores?.[llm] || {};
      const markets = discoveryCtx?.markets || [];
      const categories = Object.keys(scores || {});

      categories.forEach((category) => {
        const categoryScores = scores?.[category] || {};

        markets.forEach((market) => {

          // ✅ selectedPersona-level mapping added
          const marketScores =
            categoryScores?.[market]?.[selectedPersona] || [];

          const primaryMarketScore =
            categoryScores?.[primaryMarket]?.[selectedPersona] || [];

          if (!Array.isArray(marketScores) || marketScores.length === 0) {
            console.warn(
              `No marketScores found for llm "${llm}", category "${category}", market "${market}", persona "${selectedPersona}"`
            );
            return;
          }

          if (!brandScoresMap[llm]) brandScoresMap[llm] = {};
          if (!brandScoresMap[llm][category]) brandScoresMap[llm][category] = {};

          const marketValues = [
            ...(marketScores[0] ? [marketScores[0]] : []),
            ...(Array.isArray(primaryMarketScore)
              ? primaryMarketScore.slice(1)
              : []),
          ].map((item) =>
            item && type in item ? item[type] : null
          );

          if (!mainBrandProduct && marketScores[0]?.name) {
            mainBrandProduct = marketScores[0].name;
          }

          brandScoresMap[llm][category][market] = marketValues;
        });
      });
    });

    return { brandScoresMap, mainBrandProduct };
  };


  const getIndexScoreMetaData = () => {
    const markets = discoveryCtx.markets;
    let indexScoreMetaData = [];
    llms.forEach((llm) => {
      markets.map((market) => {
        const brandIndexScores = discoveryCtx?.brand_scores?.[llm] || {};
        const categories = Object.keys(brandIndexScores);
        categories.map((category) => {

          indexScoreMetaData[category] = {};
          const brandScore = brandIndexScores[category] || {};
          const marketScore = brandScore[market] || {};
          const personaScore = marketScore[selectedPersona] || [];
          indexScoreMetaData = indexScoreMetaData.concat(
            personaScore.slice(0, 1).map((score) => {
              return {
                ...score,
                category: category,
                market: market,
                llm: llm,
                persona: selectedPersona,
                geography: ""
              };
            })
          );
        });
      })
    })
    return indexScoreMetaData;
  };

  return (
    <>
      <div className="Heading-checkbox">
        <div className={classes.dropdownWrapper}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h5>Market Summary</h5>
            {discoveryCtx.state.showReportCheckbox && (
              <Checkbox
                checked={checked}
                onChange={() => {
                  discoveryCtx?.clickComponentCheckbox({
                    uniqueKey,
                    filter: {
                      id: id,
                      title: "Market Summary",
                      tab: tab.marketOverview,
                      uniqueKey,
                      llm: null,
                      market: null
                    },
                    checked,
                    id,
                  });
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            )}
          </div>
          <div className={classes.marketWrapper}>
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedPersona}
              label={"Persona"}
              id={filterKey.persona}
              options={personaOptions}
              onChange={(e) => {
                discoveryCtx.updateSelectedPersona(e.target.value);
              }}
            />
            <MUISelect
              fullWidth={false}
              optionValue={discoveryCtx.state.selectedCategory}
              label={"Category"}
              id={filterKey.category}
              options={(discoveryCtx.category || []).map((category) => {
                return {
                  name: category,
                  value: category,
                };
              })}
              onChange={(e) => {
                discoveryCtx.updateSelectedCategory(e.target.value);
              }}
            />
            <div className={classes.shareIcon}>
              <MUIIconButton
                title="Click to Share"
                onClick={() => setShowShareModal(true)}
              >
                <ShareOutlinedIcon color="primary" />
              </MUIIconButton>
            </div>
          </div>
        </div>


      </div>
      <hr />
      <MultiComparisonComponent
        fetchRealTimeActionsSources={() => { }}
        sourceURLIds={[]}
        reachSourceData={{}}
        sentimentSourceData={{}}
        categoryDimensionRatingSource={{}}
        secCategoryIndexScoreMetaData={{}}
        coreAttSourceData={{}}
        positiveAttSource={{}}
        negativeAttSource={{}}
        customerId={1}
        selectedInput={{
          llm: primary_llm,
          market: selectedMarket,
          persona: selectedPersona,
          brand: discoveryCtx.entity,
          product: discoveryCtx.type == "product" ? true : false,
          geography: "",
          category: selectedCategory,
        }}
        productTaxonomyData={null}
        secCategoryBrandFav={{}}
        secCategoryReach={{}}
        secCategoryBrandIndex={{}}
        indexScoreMetaData={getIndexScoreMetaData()}
        compCoreAttributes={{}}
        compCategoryDimensions={{}}
        pastCompCategoryDimensions={{}}
        pastCompCoreAttributes={{}}
        pastsecCategoryBrandIndex={{}}
        pastIndexScoreObj={{}}
        brandIndex={getBrandScores("total").brandScoresMap}
        brandReach={getBrandScores("rank").brandScoresMap}
        brandFav={getBrandScores("favorability").brandScoresMap}
        positiveAttributes={{}}
        negativeAttributes={{}}
        llmDomains={{}}
        geoLogo={{}}
        activeTab={"category"}
        brandDomains={{}}
        brandProduct={getBrandScores("favorability").mainBrandProduct}
        type={discoveryCtx.type == "brand" ? "Brand" : "Product"}
        brandProductCategory={discoveryCtx.markets}
        isBrandAuditPage={true}
        isBrandAuditMarketPage={true}
        isOverview={true}
        isMarketOverview={discoveryCtx.markets}
        id={id}
        contextData={discoveryCtx}
      />
      {showShareModal &&
        <Modal
          height="60%"
          title="Share Link"
          open={showShareModal}
          handleClose={() => setShowShareModal(false)}
        >
          <Share setShowShareModal={setShowShareModal} />
        </Modal>
      }
    </>
  );
}
